import React, { useState } from 'react';
import t from '~t';
import View from './view';
import Contextmenu from './contextmenu';
import { Alert, Confirm, Prompt, Error } from '~co/overlay/dialog';

function CollectionsGroup({
  _id,
  title,
  system,
  hidden,
  active = false,
  events = {}, //same as ...items/index
  actions = {}, //redux collections
  ...props
}) {
  const [menu, setMenu] = useState(false);

  const onToggleClick = () => actions.groupToggle(_id);

  const handlers = {
    onClick: () => {
      if (events.onGroupClick)
        return events.onGroupClick({
          _id,
          title,
          system,
          hidden,
          active,
          events,
          actions,
          ...props,
        });

      onToggleClick();
    },

    onCreateNewCollectionClick: (e) => {
      e.preventDefault();
      e.stopPropagation();
      actions.addBlank(_id);
    },

    onCreateNewGroupClick: async () => {
      const title = await Prompt(t.s('enterTitle'));
      if (title) actions.groupCreate(title);
    },

    onSelectAll: () => actions.selectAll(_id),

    onRenameClick: async () => {
      const newTitle = await Prompt(t.s('enterTitle'), title);

      if (newTitle) actions.groupRename(_id, newTitle);
    },

    onToggleClick,

    onRemoveClick: () => {
      actions.groupRemove(_id, undefined, () => {
        Alert(t.s('removeGroupError'), { variant: 'error' });
      });
    },

    onCollapseAllClick: () => {
      actions.toggle();
    },

    onSortAllByTitleClick: async () => {
      if (await Confirm(t.s('areYouSure'), { variant: 'warning' }))
        actions.reorder('title');
    },

    onCleanClick: async () => {
      if (await Confirm(t.s('areYouSure'), { variant: 'warning' }))
        actions.clean(
          (count) =>
            Alert(
              `${count} ${t.s('removeCollectionSuccess').toLowerCase()}`,
            ),
          Error,
        );
    },

    onContextMenu: (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.target.focus();
      setMenu(true);
    },

    onContextMenuClose: () => setMenu(false),
  };

  const viewProps = {
    _id,
    title,
    system,
    hidden,
    active,
    events,
    actions,
    ...props,
  };

  return (
    <>
      <View {...viewProps} {...handlers} />

      {menu ? <Contextmenu {...viewProps} {...handlers} /> : null}
    </>
  );
}

export default React.memo(CollectionsGroup);
